// 価格変更可否・品番確定可否・削除メニュー可否など権限まわりの判定をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createHinbanPermissionService(deps) {
    const {
        DicVal,
        brandDepartmentAuthRequestSeqRef,
        brandDepartmentDeleteDisabledRef,
        fnc,
        formstatus,
        getEntryDataValue,
        hinbanDeleteMenuDisabled,
        hinbanFixEnableRequestSeqRef,
        isEmpty,
        priceChangeEnableRef,
        setHinbanDeleteMenuDisabled,
        setHinbanFixEnabled,
        setPriceFieldLocked,
        synFlg1DeleteDisabledRef
    } = deps;

    function loadPriceChangeEnable(oppiCode, options) {
        const requestCode = String(isEmpty(oppiCode) ? "" : oppiCode).trim();
        const shouldLog = !!DicVal(options, "shouldLog", false);
        if (isEmpty(requestCode)) {
            priceChangeEnableRef.current = null;
            if (shouldLog) {
            }
            return;
        }
        fnc.current.postaxios("hinbanmaster/GetPriceChangeEnable",
            { OppiCode: requestCode },
            {
                onSuccess: function (data) {
                    const enabled = String(DicVal(data.returnData, "Price_Change_Enable", "false")).toLowerCase() === "true";
                    priceChangeEnableRef.current = enabled;
                    if (formstatus === "ENTRY FORM") {
                        setPriceFieldLocked(!enabled);
                    }
                    if (shouldLog) {
                    }
                },
                onError: function (data) {
                    priceChangeEnableRef.current = null;
                    if (formstatus === "ENTRY FORM") {
                        setPriceFieldLocked(true);
                    }
                    if (shouldLog) {
                    }
                }
            }, true
        );
    }
    function loadHinbanFixEnableByBrand(brandCode) {
        const requestBrandCode = String(isEmpty(brandCode) ? "" : brandCode).trim();
        const requestSeq = hinbanFixEnableRequestSeqRef.current + 1;
        hinbanFixEnableRequestSeqRef.current = requestSeq;
        setHinbanFixEnabled(false);
        if (isEmpty(requestBrandCode)) return;

        fnc.current.postaxios("hinbanmaster/GetHinbanFixEnableByBrand",
            { PDT_BRDCODE: requestBrandCode },
            {
                onSuccess: function (data) {
                    if (hinbanFixEnableRequestSeqRef.current !== requestSeq) return;
                    const enabledValue = String(DicVal(data.returnData, "HinbanFix_Enable", DicVal(data.returnData, "HinbanFixEnable", DicVal(data, "request", "false")))).toLowerCase();
                    setHinbanFixEnabled(enabledValue === "true" || enabledValue === "1");
                },
                onError: function () {
                    if (hinbanFixEnableRequestSeqRef.current !== requestSeq) return;
                    setHinbanFixEnabled(false);
                }
            }, true
        );
    }
    function setHinbanDeleteDisabled(disabled) {
        setHinbanDeleteMenuDisabled(!!disabled);
        setTimeout(() => applyHinbanDeleteMenuDisabled(!!disabled), 0);
    }
    function refreshHinbanDeleteDisabled() {
        setHinbanDeleteDisabled(brandDepartmentDeleteDisabledRef.current || synFlg1DeleteDisabledRef.current);
    }
    function setBrandDepartmentDeleteDisabled(disabled) {
        brandDepartmentDeleteDisabledRef.current = !!disabled;
        refreshHinbanDeleteDisabled();
    }
    function updateSynFlg1DeleteDisabled(targetData) {
        const synFlg1 = String(getEntryDataValue(targetData || {}, "PDT_SYNFLG1", "")).trim();
        synFlg1DeleteDisabledRef.current = synFlg1 === "3";
        refreshHinbanDeleteDisabled();
    }
    function applyHinbanDeleteMenuDisabled(disabled = hinbanDeleteMenuDisabled) {
        if (typeof document === "undefined") return;
        const deleteLabel = "削除";
        const nodes = Array.from(document.querySelectorAll(".MuiListItem-button, [role='button']"));
        nodes.forEach((node) => {
            const icons = Array.from(node.querySelectorAll(".material-icons"));
            const hasDeleteIcon = icons.some((icon) => String(icon.textContent ?? "").trim() === "delete");
            const isDeleteMenu = hasDeleteIcon && String(node.textContent ?? "").indexOf(deleteLabel) !== -1;
            if (!isDeleteMenu) return;

            if (disabled && formstatus === "ENTRY FORM") {
                node.dataset.hinbanDeleteDisabled = "1";
                node.dataset.hinbanDeletePrevTabIndex = node.getAttribute("tabindex") ?? "";
                node.setAttribute("aria-disabled", "true");
                node.setAttribute("disabled", "disabled");
                node.setAttribute("tabindex", "-1");
                node.style.pointerEvents = "none";
                node.style.opacity = "0.38";
                node.style.cursor = "default";
                return;
            }

            if (node.dataset.hinbanDeleteDisabled === "1") {
                const prevTabIndex = node.dataset.hinbanDeletePrevTabIndex;
                delete node.dataset.hinbanDeleteDisabled;
                delete node.dataset.hinbanDeletePrevTabIndex;
                node.removeAttribute("aria-disabled");
                node.removeAttribute("disabled");
                if (isEmpty(prevTabIndex)) node.removeAttribute("tabindex");
                else node.setAttribute("tabindex", prevTabIndex);
                node.style.pointerEvents = "";
                node.style.opacity = "";
                node.style.cursor = "";
            }
        });
    }
    function loadUserAllowedBrandDepartment(brandCode) {
        const requestBrandCode = String(isEmpty(brandCode) ? "" : brandCode).trim();
        const requestSeq = brandDepartmentAuthRequestSeqRef.current + 1;
        brandDepartmentAuthRequestSeqRef.current = requestSeq;
        if (isEmpty(requestBrandCode)) {
            setBrandDepartmentDeleteDisabled(false);
            return;
        }

        fnc.current.postaxios("hinbanmaster/GetUserAllowedBrandDepartment",
            { PDT_BRDCODE: requestBrandCode },
            {
                onSuccess: function (data) {
                    if (brandDepartmentAuthRequestSeqRef.current !== requestSeq) return;
                    const allowedValue = String(DicVal(data.returnData, "UserAllowedBrandDepartment", DicVal(data, "request", "true"))).toLowerCase();
                    setBrandDepartmentDeleteDisabled(!(allowedValue === "true" || allowedValue === "1"));
                },
                onError: function () {
                    if (brandDepartmentAuthRequestSeqRef.current !== requestSeq) return;
                    setBrandDepartmentDeleteDisabled(true);
                }
            }, true
        );
    }

    return {
        loadPriceChangeEnable,
        loadHinbanFixEnableByBrand,
        setHinbanDeleteDisabled,
        refreshHinbanDeleteDisabled,
        setBrandDepartmentDeleteDisabled,
        updateSynFlg1DeleteDisabled,
        applyHinbanDeleteMenuDisabled,
        loadUserAllowedBrandDepartment
    };
}
